import {
  Component, ComponentFactoryResolver, ElementRef, OnInit, Type, ViewChild,
  ViewContainerRef
} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {IVirtualGridCollectionState} from '@shared/store/reducers/virtual-grid.reducer';
import {DialogModel} from '@shared/models/dialog.model';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {IPlatformToolComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';

@Component({
    standalone: false,
    selector: 'app-add-preset-countries',
  templateUrl: './add-preset-countries.component.html',
  styleUrls: ['./add-preset-countries.component.scss']
})
export class AddPresetCountriesComponent implements OnInit {
  data: DialogModel;
  @ViewChild('PresetCountriesSelector', {read: ViewContainerRef, static: true})countryContainer ;
  createPresetCountriesErrors: any;
  inputForm: any;
  valueChanged = false;
  isReady: boolean;
  dialogView: IDialogView;
  platformToolComponent: IPlatformToolComponent;
  constructor(private formBuilder: FormBuilder,
              private store: Store<IVirtualGridCollectionState>,
              private componentFactoryResolver: ComponentFactoryResolver
  ) {
    this.createPresetCountriesErrors = {
      title   : {},
    };
  }

  ngOnInit(): void {
    this.inputForm = this.formBuilder.group({
      title : [ this.data.input.title,  Validators.compose([Validators.required, Validators.maxLength(40)]) ]
    });
    this.loadComponent();
  }

  private loadComponent() {
    this.isReady = true;
    // let componentFactory = this.data.componentFactory;
    // if (!componentFactory) {
    //   const componentFactoryResolver = this.data.componentFactoryResolver ? this.data.componentFactoryResolver : this.componentFactoryResolver;
    //   componentFactory = RootDynamicComponentHelper
    //     .getComponentFactoryByType(componentFactoryResolver, currentComponent);
    // }
    const currentComponent = <Type<any>>RootDynamicComponentHelper.getComponent('CountryListDialogueComponent');
    const viewContainerRef = this.countryContainer;
    viewContainerRef.clear();
    const component = viewContainerRef.createComponent(currentComponent);
    this.dialogView = component.instance as IDialogView;
    this.dialogView.data = this.data;
    this.platformToolComponent = component.instance as IPlatformToolComponent;
    // this.platformToolComponent.selectedTab = this.selectedTab;
    // this.platformToolComponent.magicLinkModel = this.magicLinkModel;
    // this.platformToolComponent.invalidateSubject = this.invalidateSubject;
    // this.platformToolComponent.handler = this.handler;
    if (this.platformToolComponent.onLoad) {
      this.platformToolComponent.onLoad();
    }
  }

  onOkClicked(): boolean {
    const control = this.inputForm.get('title');
    if (control) {
      this.data.input.title = control.value;
    }
    if (!this.data.input.title || this.data.input.title.length === 0) {
      return false;
    }

    return true;
  }

}
